export function loadStyleString(css) {
  let style = document.createElement("style");
  style.type = "text/css";
  try {
    style.appendChild(document.createTextNode(css));

  } catch (e) {
    style.styleSheet.cssText = css;  //兼容IE8-
  }
  let head = document.getElementsByTagName("head")[0];
  head.appendChild(style);
}

export function iconStyle(data) {
  return '.' + data.iconName + '{background: url(' + data.path
    + ') center no-repeat; background-size: contain; font-size: '
    + data.iconSize
    + 'px;}.' + data.iconName + ':before{content: "替";font-size:'
    + data.iconSize
    + 'px;visibility: hidden;}'
}



// WEBPACK FOOTER //
// ./src/lib/js/common.js